import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import UsuarioLogado from '../domain/usuarioLogado';

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		token: '',
		usuarioLogado: new UsuarioLogado(),
    autenticados: [],
    funcionario: {},
		graus: [],
		funcionarioCadastrado: {},
		cadastroModelo: {},
		estados: [],
    situacaoRecad: null,
    municipioSelecionado: '',
	},
	mutations: {
		setToken(state, payload) {
			state.token = payload
		},
		setUsuarioLogado(state, payload) {
			state.usuarioLogado = payload
		},
		setAutenticados(state, payload) {
			state.autenticados = [...payload]
    },
    setFuncionario(state, payload) {
			state.funcionario = payload
		},
		setGraus(state, payload) {
			state.graus = payload
		},
		setFuncionarioCadastrado(state, payload) {
			state.funcionarioCadastrado = payload
		},
		setEstados(state, payload) {
			state.estados = payload
		},
		setCadastroModelo(state, payload) {
			state.cadastroModelo = payload
		},
		setArquivosRecadastramento(state, payload) {
			state.funcionarioCadastrado.anexos = payload
		},
    setSituacaoRecad(state, situacaoRecad) {
      state.situacaoRecad = situacaoRecad
    },
    setMunicipioSelecionado(state, payload) {
      state.municipioSelecionado = payload;
    },
	},
  actions: {
    updateSituacaoRecad({ commit }, situacaoRecad) {
      commit('setSituacaoRecad', situacaoRecad);
    },
  },
  getters: {
    getSituacaoRecad: (state) => {
      return state.situacaoRecad;
    },
  },
	plugins: [
		createPersistedState({
			storage: window.sessionStorage
		})
	]
})



// WEBPACK FOOTER //
// ./src/vuex/store.js